import { DataViewTypes } from '@mode/shared/contract-common';

/**
 * Return state partial needed to change a datasetResult back to a `pending` state.
 */
export function getPendingDatasetResultUpdates(): Partial<DataViewTypes.DatasetResult> {
  const datasetResultPendingState: Partial<DataViewTypes.DatasetResult> = {
    queryRunState: DataViewTypes.QueryRunStatus.Pending,
    contentLength: null,
  };
  return datasetResultPendingState;
}
